(function () {
  'use strict';

  var initialized = false;

  function debounce(fn, wait) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function saveCartNote(note) {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart)
      ? window.theme.routes.cart + '/update.js'
      : '/cart/update.js';

    return fetch(cartUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note || '' })
    }).catch(function (err) {
      console.error(err);
    });
  }

  function addSurpriseToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: {
          _gift_surprise: 'true'
        }
      })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error(err.description || 'Could not add surprise to cart');
        });
      }
      return res.json();
    });
  }

function refreshCart() {
    var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart)
      ? window.theme.routes.cart + '.js'
      : '/cart.js';

    return fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: { cart: cart },
          bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        return cart;
      })
      .catch(function (err) {
        console.error(err);
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      });
  }

  function getSurpriseProductIds(cart) {
    if (!cart || !cart.items) return [];
    return cart.items
      .filter(function (item) {
        return item.properties && item.properties._gift_surprise;
      })
      .map(function (item) {
        return String(item.product_id);
      });
  }

  function updateSelectedProducts(root, cart) {
    var selectedIds = getSurpriseProductIds(cart);
    root.querySelectorAll('[data-fclo-loved-product]').forEach(function (btn) {
      var productId = btn.getAttribute('data-product-id');
      var isSelected = selectedIds.indexOf(String(productId)) !== -1;
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      btn.classList.remove('is-loading');
    });
  }

  function bindAccordion(root) {
    root.querySelectorAll('[data-fclo-loved-accordion]').forEach(function (accordion) {
      var trigger = accordion.querySelector('[data-fclo-loved-accordion-trigger]');
      if (!trigger || trigger.dataset.fcloBound) return;
      trigger.dataset.fcloBound = 'true';

      trigger.addEventListener('click', function () {
        var isOpen = accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });
  }

  function bindTabs(root) {
    var tabs = root.querySelectorAll('[data-fclo-loved-tab]');
    var panels = root.querySelectorAll('[data-fclo-loved-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      if (tab.dataset.fcloBound) return;
      tab.dataset.fcloBound = 'true';

      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-fclo-loved-tab');

        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-fclo-loved-panel') === target;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      });
    });
  }

  function bindNote(root) {
    var noteInput = root.querySelector('[data-cart-note]');
    if (!noteInput || noteInput.dataset.fcloBound) return;
    noteInput.dataset.fcloBound = 'true';

    noteInput.addEventListener(
      'input',
      debounce(function (event) {
        saveCartNote(event.target.value);
      }, 300)
    );
  }

  function bindProducts(root) {
    root.querySelectorAll('[data-fclo-loved-product]').forEach(function (btn) {
      if (btn.dataset.fcloBound) return;
      btn.dataset.fcloBound = 'true';

      btn.addEventListener('click', function () {
        if (btn.disabled || btn.classList.contains('is-loading')) return;
        if (btn.classList.contains('is-selected')) return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var noteInput = root.querySelector('[data-cart-note]');
        var notePromise = noteInput
          ? saveCartNote(noteInput.value)
          : Promise.resolve();

        btn.classList.add('is-loading');

        notePromise
          .then(function () {
            return addSurpriseToCart(variantId);
          })
          .then(function () {
            refreshCart();
          })
          .catch(function (err) {
            btn.classList.remove('is-loading');
            console.error(err);
            window.alert(err.message || 'Could not add surprise to cart');
          });
      });
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.fcloInitialized) return;
    root.dataset.fcloInitialized = 'true';

    bindAccordion(root);
    bindTabs(root);
    bindNote(root);
    bindProducts(root);
  }

  function initAll() {
    document.querySelectorAll('[data-fclo-loved-one]').forEach(initRoot);
  }

  function onCartChange(event) {
    var cart = event.detail && event.detail.cart;
    document.querySelectorAll('[data-fclo-loved-one]').forEach(function (root) {
      updateSelectedProducts(root, cart);
    });
  }

  if (!initialized) {
    initialized = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('theme:cart:change', onCartChange);

    document.addEventListener('theme:cart:reload', function () {
      var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart)
        ? window.theme.routes.cart + '.js'
        : '/cart.js';

      fetch(cartUrl)
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-fclo-loved-one]').forEach(function (root) {
            updateSelectedProducts(root, cart);
          });
        })
        .catch(function () {});
    });
  }
})();
